module.exports = __webpack_public_path__ + "img/shy.e7c3c3f2.png";